import { Button as AIMEButton } from "tot-loft-component-library";

import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { OutlineEye, OutlineEyeOff, PaartnerLogo2 } from "./assets";
import CheckBoxComponent from "./CheckBox";
import {
  loginUser,
  googleLogin,
  microsoftLogin,
} from "./redux/slices/authThunks";
import { validateEmailWithMessage } from "./utils/regex";
import SocialButton from "./SocialButton";
import { GoogleLogin, useGoogleLogin } from "@react-oauth/google";
import { msalInstance } from "./msalConfig";
export default function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const { status, error } = useSelector((state) => state.auth);
  const [rememberMe, setRememberMe] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [generalError, setGeneralError] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const googleButtonRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setEmailError("");
    setPasswordError("");

    const emailValidation = validateEmailWithMessage(email);
    let isValid = true;

    if (!emailValidation.valid) {
      setEmailError(emailValidation.message);
      isValid = false;
    }

    if (!password || password.length < 6) {
      setPasswordError("Password must be at least 6 characters.");
      isValid = false;
    }

    if (!isValid) return;

    try {
      const res = await dispatch(loginUser({ email, password }));

      if (res.meta.requestStatus === "fulfilled" && res.payload?.user) {
        const { _id: userId, account_type } = res.payload.user;

        let baseUrl;
        switch (account_type) {
          case "vendor":
            baseUrl = process.env.REACT_APP_VENDOR_BASE_URL;
            break;
          case "partner":
            baseUrl = process.env.REACT_APP_MEMBER_BASE_URL;
            break;
          default:
            throw new Error("Unsupported account type");
        }

        // ✅ Preserve the redirect URL if provided in query params
        const params = new URLSearchParams(window.location.search);
        const redirectUrl = params.get("redirect");

        const statePayload = { email, password };
        if (redirectUrl) statePayload.redirect = redirectUrl;

        const encodedState = btoa(JSON.stringify(statePayload));

        // ✅ Pass redirect info to the OTP page
        window.location.href = `${baseUrl}/otp/${userId}?s=${encodedState}`;
      } else {
        throw new Error(res.payload || "Login failed");
      }
    } catch (error) {
      setGeneralError(
        error.message || "Something went wrong. Please try again."
      );
    }
  };
  const handleMicrosoftLogin = async () => {
    try {
      const loginResponse = await msalInstance.loginPopup({
        scopes: ["openid", "profile", "email"],
      });

      if (loginResponse.idToken) {
        dispatch(microsoftLogin(loginResponse.idToken))
          .unwrap()
          .then((res) => {
            if (res && res.user) {
              console.log(res);

              const { account_type } = res.user;
              let baseUrl;
              let redirectPath = "/";

              switch (account_type) {
                case "vendor":
                  baseUrl = process.env.REACT_APP_VENDOR_BASE_URL;
                  redirectPath = `${baseUrl}/`;
                  break;
                case "partner":
                  baseUrl = process.env.REACT_APP_MEMBER_BASE_URL;
                  redirectPath = `${baseUrl}/vendors`;
                  break;
                case "admin":
                  setGeneralError("Admin accounts are not allowed");
                  return; // Exit early to prevent redirect
                default:
                  console.error("Unsupported account type:", account_type);
                  setGeneralError("Unsupported account type");
                  return; // Exit early to prevent redirect
              }

              // Only redirect if we have a valid account type
              window.location.href = redirectPath;
            }
          })
          .catch((err) => {
            console.error("Microsoft login failed:", err);
            setGeneralError(err || "Microsoft login failed");
          });
      }
    } catch (error) {
      console.error("Microsoft login popup error:", error);
      setGeneralError(error.message || "Login popup failed");
    }
  };
  useEffect(() => {
    const initMSAL = async () => {
      await msalInstance.initialize(); // 1. Initialize
      await msalInstance.handleRedirectPromise(); // 2. Process any redirect auth
    };

    initMSAL();
  }, []);

  return (
    <RootWrapperHome>
      <Section>
        <Wrapper>
          <SignupSignin>
            <ContentBlock1>
              <Content>
                <EarningCashForMakingReferralsIsEasierThanEver>
                  Welcome to Paartner
                </EarningCashForMakingReferralsIsEasierThanEver>
                <DiscoverPaartnerSTrustedAlliesReadyToHelpYourFriendsWithTheServicesAndMarTechTheyNeedToSucceed>
                  Enter your email address and password to continue.
                </DiscoverPaartnerSTrustedAlliesReadyToHelpYourFriendsWithTheServicesAndMarTechTheyNeedToSucceed>
              </Content>
            </ContentBlock1>
            <Frame58>
              <PRTNR.Input
                label="Email address"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (emailError) {
                    const check = validateEmailWithMessage(e.target.value);
                    setEmailError(check.valid ? "" : check.message);
                  }
                }}
                error={!!emailError}
                errorMessage={emailError}
              />

              <PRTNR.Input
                label="Password"
                type={showPassword ? "text" : "password"}
                icon={showPassword ? OutlineEye : OutlineEyeOff}
                onIconClick={() => setShowPassword(!showPassword)}
                value={password}
                onChange={(e) => {
                  const val = e.target.value;
                  setPassword(val);
                  if (passwordError && val.length >= 6) {
                    setPasswordError("");
                  }
                }}
                error={!!passwordError}
                errorMessage={passwordError}
              />
              {/* {generalError && <ErrorMessage>{generalError}</ErrorMessage>} */}

              <Frame61>
                <CheckBoxComponent
                  label={"Remember me"}
                  checked={rememberMe}
                  onChange={(e) => {
                    setRememberMe(e.target.checked);
                  }}
                />
                <Frame62 onClick={() => navigate("/forgot-password")}>
                  <ForgotPassword>Forgot password ?</ForgotPassword>
                </Frame62>
              </Frame61>
              <Frame59>
                <AIMEButton
                  size="small"
                  onClick={(e) => handleSubmit(e)}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "row",
                    alignItems: "center",
                    flex: "none",
                    gap: "10px",
                    borderRadius: "48px",
                    width: "320px",
                    background: "rgb(33, 37, 67)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    boxSizing: "border-box",
                    padding: "16px 32px",
                    "&:hover": {
                      background: "rgb(33, 37, 67)",
                      opacity: "0.9",
                    },
                    "@media (max-width: 768px)": {
                      width: "260px",
                    },
                    "@media (max-width: 480px)": {
                      width: "100%",
                    },
                  }}
                >
                  <span
                    style={{
                      color: "white",
                      textOverflow: "ellipsis",
                      fontSize: "16px",
                      fontFamily: "Montserrat, sans-serif",
                      fontWeight: "600",
                      lineHeight: "110%",
                      textAlign: "left",
                    }}
                  >
                    Login
                  </span>
                </AIMEButton>
              </Frame59>
              <Frame62>
                <ContinueWith>
                  ___________ Or Continue with ____________
                </ContinueWith>
                <ContinueWith2>___ Or Continue with ___</ContinueWith2>
              </Frame62>
              <Frame1628>
                <GoogleLoginWrapper>
                  <GoogleLogin
                    ref={googleButtonRef}
                    onSuccess={(credentialResponse) => {
                      if (credentialResponse.credential) {
                        dispatch(googleLogin(credentialResponse.credential))
                          .unwrap()
                          .then((res) => {
                            if (res && res.user) {
                              const { account_type } = res.user;

                              let baseUrl;
                              let redirectPath = "/";

                              switch (account_type) {
                                case "vendor":
                                  baseUrl =
                                    process.env.REACT_APP_VENDOR_BASE_URL;
                                  redirectPath = `${baseUrl}/`;
                                  break;
                                case "partner":
                                  baseUrl =
                                    process.env.REACT_APP_MEMBER_BASE_URL;
                                  redirectPath = `${baseUrl}/vendors`;
                                  break;
                                case "admin":
                                  setGeneralError(
                                    "Admin accounts are not allowed"
                                  );
                                  return;
                                default:
                                  console.error(
                                    "Unsupported account type:",
                                    account_type
                                  );
                                  setGeneralError("Unsupported account type");
                                  return;
                              }

                              window.location.href = redirectPath;
                            }
                          })
                          .catch((err) => {
                            setGeneralError(err || "Google login failed");
                            console.error("Google login failed:", err);
                          });
                      }
                    }}
                    onError={() => {
                      setGeneralError("Google login failed");
                      console.log("Login Failed");
                    }}
                  />

                  <CustomGoogleButton
                    type="button"
                    onClick={() => {
                      // Trigger the hidden Google button
                      const googleBtn = document.querySelector(
                        '[role="button"][aria-labelledby]'
                      );
                      if (googleBtn) googleBtn.click();
                    }}
                  >
                    <img
                      src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
                      alt="Google"
                    />
                    <span>Google</span>
                  </CustomGoogleButton>
                </GoogleLoginWrapper>

                <SocialButton
                  label="Microsoft"
                  icon="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
                  onClick={handleMicrosoftLogin}
                />
              </Frame1628>

              {generalError && <ErrorMessage>{generalError}</ErrorMessage>}
              {/* <SocialButton
                label="Google"
                icon="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
                onClick={() => login()}
              /> */}

              {/* <SocialButton
                  label="Apple"
                  icon="https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg"
                />

                <SocialButton
                  label="Microsoft"
                  icon="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
                />

                <SocialButton
                  label="Linkedin"
                  icon="https://upload.wikimedia.org/wikipedia/commons/8/81/LinkedIn_icon.svg"
                /> */}
              <Frame1629>
                <SignUpFrame
                  onClick={() => {
                    const params = new URLSearchParams(window.location.search);
                    const redirect = params.get("redirect");
                    const memberSignupUrl = `${
                      process.env.REACT_APP_MEMBER_BASE_URL
                    }/signup${
                      redirect
                        ? `?redirect=${encodeURIComponent(redirect)}`
                        : ""
                    }`;
                    window.location.href = memberSignupUrl;
                  }}
                >
                  Don’t have an account? <span>Join Now - It's Free</span>
                </SignUpFrame>
              </Frame1629>
            </Frame58>
          </SignupSignin>
        </Wrapper>
      </Section>
    </RootWrapperHome>
  );
}
const FullWidthWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const RootWrapperHome = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
`;

const Section = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background: rgb(241, 245, 249);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: clamp(1rem, 5vw, 3.75rem);
  flex-shrink: 0;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  max-width: 1200px;
  width: 100%;
  box-sizing: border-box;
`;

const SignupSignin = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const ContentBlock1 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 32px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Content = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  flex: 1;
  max-width: 1200px;
  width: 100%;
  box-sizing: border-box;
`;
const ErrorMessage = styled.span`
  color: rgb(220, 38, 38);
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  margin-top: 4px;
  text-align: left;
  width: 100%;
`;
const EarningCashForMakingReferralsIsEasierThanEver = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(24px, 2.5vw, 48px);
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  letter-spacing: -1px;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const DiscoverPaartnerSTrustedAlliesReadyToHelpYourFriendsWithTheServicesAndMarTechTheyNeedToSucceed = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(16px, 2vw, 20px);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame58 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  flex: none;
  gap: 24px;
  border: solid 1px rgba(136, 136, 136, 0.1);
  border-radius: 32px;
  width: 560px;
  background: rgb(226, 232, 240);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 32px;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Frame61 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame62 = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: 8px;
  box-sizing: border-box;
  cursor: pointer;
`;
const Frame1628 = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  width: 320px;
  padding-bottom: 32px;

  @media (max-width: 480px) {
    width: 100%;
    /* grid-template-columns: 1fr; stack vertically on small screens */
  }
`;
const Frame1629 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;
const SignUpFrame = styled.div`
  color: var(--Color-Text-Text, #212543);
  text-align: center;

  /* P3 */
  font-family: Montserrat;
  font-size: var(--Fonts-P3, 16px);
  font-style: normal;
  font-weight: 500;
  line-height: 160%; /* 25.6px */
  letter-spacing: -0.16px;
  span {
    color: var(--Color-Text-Text, #212543);

    /* P1 - bold */
    font-family: Montserrat;
    font-size: var(--Fonts-P1, 20px);
    font-style: normal;
    font-weight: 700;
    line-height: 160%;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
`;
const ForgotPassword = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: center;
`;

const Frame59 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const ContinueWith = styled.div`
  color: var(--Color-Text-Text, #212543);
  text-align: center;
  font-family: Montserrat;
  font-size: var(--Fonts-P3, 16px);
  font-style: normal;
  font-weight: 500;
  line-height: 160%; /* 25.6px */
  letter-spacing: -0.16px;
  @media (max-width: 480px) {
    display: none;
  }
`;
const ContinueWith2 = styled.div`
  display: none;
  @media (max-width: 480px) {
    display: block;
    color: var(--Color-Text-Text, #212543);
    text-align: center;
    font-family: Montserrat;
    font-size: var(--Fonts-P3, 16px);
    font-style: normal;
    font-weight: 500;
    line-height: 160%; /* 25.6px */
    letter-spacing: -0.16px;
  }
`;
const GoogleLoginWrapper = styled.div`
  width: 100%;

  /* Hide the default Google button */
  > div {
    display: none;
  }
`;

const CustomGoogleButton = styled.button`
  display: flex;
  width: 100%;
  padding: var(--sizing-sizing-07, 16px);
  justify-content: center;
  align-items: center;
  gap: var(--sizing-sizing-06, 12px);
  flex: 1 0 0;
  border-radius: 48px;
  background: var(--social-buttons-primary-default-background, #ffffff);
  border: none;
  padding: 12px 24px;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: background-color 0.2s ease, opacity 0.2s ease;
  width: 100%;

  &:hover {
    background-color: #f3f4f6;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
    background-color: #f3f4f6;
  }

  span {
    color: var(--Color-Brand-Primary, #212543);
    text-align: center;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 150% */
  }

  img {
    width: 24px;
    height: 24px;
  }
`;
